import { createSlice } from '@reduxjs/toolkit';
import { deleteDoc, doc } from "firebase/firestore";
import { db } from "../firebase";


export const appSlice = createSlice({
  name: 'app',
  initialState: {
    channelID: null,
    channelName: null,
  },
  reducers: {
    setChannelInfo: (state, action) => {
      state.channelID = action.payload.channelID;
      state.channelName = action.payload.channelName;
    },
    deleteChannel: (state, action) => {
        const { channelID } = action.payload;
  
          try {
            deleteDoc(doc(db, "channels", channelID));
  
            state.channelID = null;
            state.channelName = null;
          } catch (error) {
            console.error("Error deleting channel:", error);
          } 
      },
    },
});

export const { setChannelInfo } = appSlice.actions;

export const { deleteChannel } = appSlice.actions;

export const selectChannelID = (state) => state.app.channelID;

export const selectChannelName = (state) => state.app.channelName;

export default appSlice.reducer;
